import { gql } from '@apollo/client'

interface Token {
  address: string
  symbol: string
  name: string
  decimals: number
}

interface AprInfo {
  averageApr: string
  timestamp: string
}

interface FeeInfo {
  burn0: string
  burn1: string
  collect0: string
  collect1: string
  feeCheckpoint0: string
  feeCheckpoint1: string
  checkpointTimestamp: string
}

export interface VaultData {
  id: string
  blockCreated: string
  timestampCreated: string
  manager: string
  address: string
  uniswapPool: string
  token0: Token
  token1: Token
  feeTier: number
  liquidity: string
  positionId: string
  lowerTick: string
  upperTick: string
  managerFee: string
  totalSupply: string
  name: string
  feeInfo: FeeInfo
  apr: AprInfo
}

export const VaultsQuery = gql`
query {
  vaults {
    id
    blockCreated
    timestampCreated
    manager
    address
    uniswapPool
    token0 {
      name
      address
      symbol
      decimals
    }
    token1 {
      name
      address
      symbol
      decimals
    }
    feeTier
    liquidity
    positionId
    lowerTick
    upperTick
    managerFee
    totalSupply
    name
    feeInfo {
      burn0
      burn1
      collect0
      collect1
      feeCheckpoint0
      feeCheckpoint1
      checkpointTimestamp
    }
    apr {
      averageApr
      timestamp
    }
  }
}`;